import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import backIcon from "../../assets/icons/backIcon.svg";
import { Link } from 'react-router-dom';
import Header from '../../components/Shared/Header';
import { getExploitationInfo } from '../../Utils/exploitations/exploitations';
import IrrigationTable from '../../components/Informations/irrigation/IrrigationTable';
import SoilInfoPage from '../../components/Informations/soil/SoilInfoPage';
import SoilIrrigationMetricsGraphs from '../../components/Informations/SoilIrricharts/SoilIrrigationMetricsGraphs';
import IrrigationDashboard from '../../components/Informations/irrigation/IrrigationDashboard';
import ExpDetails from '../../components/Informations/details/ExpDetails';


const InfoPage = () => {
  const { exploitationId, infoType } = useParams();
  const [currentExploitation, setCurrentExploitation] = useState(null);

  const infoTypes = [
    { key: 'irrigation', label: 'Irrigation' },
    { key: 'detail', label: 'Détails' },
    { key: 'sol', label: 'Sol' },
    { key: 'graphe-combine', label: 'Graphe combiné' }
  ];

  const renderInfoComponent = () => {
    switch (infoType) {
      case 'irrigation':
        return <IrrigationDashboard exploitationId={exploitationId}/>;
      case 'detail':
        return <ExpDetails exploitationId={exploitationId} />;
      case 'sol':
        return <SoilInfoPage />;
      case 'graphe-combine':
        return <SoilIrrigationMetricsGraphs />;
      default:
        return <IrrigationTable />;
    }
  }


  useEffect(() => {
    const fetchExploitation = async () => {
      try {
        const res = await getExploitationInfo(exploitationId);
        setCurrentExploitation(res.data);
      } catch (error) {
        console.error('Erreur lors de la récupération des données:', error);
      }
    };

    fetchExploitation();
  }, [exploitationId]);


  return (
    <div className="bg-white h-full">
      <Header title={`
                ${currentExploitation?.exploitation_name} - ${infoTypes.find(type => type.key === infoType)?.label} 
              `} />
      <div className="h-[calc(100%-100px)] p-6">
        <Link
          onClick={() => window.history.back()}
          className="cursor-pointer flex pl-5 gap-2 mt-4"
        >
          <img src={backIcon} alt="" className="w-5" />{" "}
          <div className="font-semibold text-base text-indigo-600">
            {" "}
            Retour
          </div>
        </Link>
        <div className='flex justify-center'>
          {renderInfoComponent()}
        </div>
      </div>
    </div>

  );
}

export default InfoPage